import React, { useState } from 'react';
import { Layout, Menu, Button } from 'antd';
import {
  TeamOutlined, InboxOutlined, FileTextOutlined, NumberOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
} from '@ant-design/icons';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { isAdminUser } from '../../utils/auth';
import UsersPage from './Users/UsersPage';
import InventorySection from './System/InventorySection';
import DocumentsSection from './Documents/DocumentsSection';
import DocumentSequencesSection from './System/DocumentSequencesSection';

const { Sider, Content } = Layout;

// El cliente solo sabe si el usuario es superadmin (esAdmin del token); los
// permisos por módulo los aplica el backend.
const SECTIONS = [
  { key: 'usuarios', label: 'Usuarios', icon: <TeamOutlined />, component: UsersPage },
  { key: 'inventario', label: 'Inventario', icon: <InboxOutlined />, component: InventorySection, adminOnly: true },
  { key: 'documentos', label: 'Documentos', icon: <FileTextOutlined />, component: DocumentsSection, adminOnly: true },
  { key: 'consecutivos', label: 'Consecutivos', icon: <NumberOutlined />, component: DocumentSequencesSection, adminOnly: true },
];

const SettingsCenterPage = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const [collapsed, setCollapsed] = useState(false);

  const isAdmin = isAdminUser();
  const allowed = SECTIONS.filter((s) => !s.adminOnly || isAdmin);
  const active = allowed.find((s) => s.key === section);

  // Sección inexistente o sin acceso: a la primera permitida.
  if (!active) {
    return <Navigate to={`/configuracion/${allowed[0].key}`} replace />;
  }

  const ActiveSection = active.component;

  return (
    <Layout style={{ background: 'transparent' }}>
      <Sider
        theme="light"
        width={190}
        collapsedWidth={56}
        collapsed={collapsed}
        style={{ alignSelf: 'flex-start', borderRadius: 8, overflow: 'hidden' }}
      >
        {/* El trigger de Sider va fijo al fondo de la ventana; aquí el menú no ocupa toda la altura. */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: collapsed ? 'center' : 'space-between',
            height: 44,
            padding: collapsed ? 0 : '0 8px 0 16px',
            borderBottom: '1px solid var(--fc-border)',
          }}
        >
          {!collapsed && (
            <span style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 1.2, color: 'var(--fc-text-muted)' }}>
              Configuración
            </span>
          )}
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            title={collapsed ? 'Expandir menú' : 'Contraer menú'}
            aria-label={collapsed ? 'Expandir menú' : 'Contraer menú'}
          />
        </div>
        <Menu
          mode="inline"
          selectedKeys={[active.key]}
          items={allowed.map(({ key, label, icon }) => ({ key, label, icon }))}
          onClick={({ key }) => navigate(`/configuracion/${key}`)}
          style={{ borderInlineEnd: 'none' }}
        />
      </Sider>
      <Content style={{ minWidth: 0 }}>
        <ActiveSection />
      </Content>
    </Layout>
  );
};

export default SettingsCenterPage;
